<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">授权人：</span>
        </div>
        <el-select v-model="formData.codeInResourcePerson"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod"
                   placeholder="请输入关键词查询">
          <el-option v-for="item in responsiblePersonList" :key="item._value"
                     :label="item._label" :value="item._value">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">备注：</span>
        </div>
        <el-input v-model="formData.memo" size="small" style="width: 280px" />
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import md5 from 'js-md5'
  import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../../components/Button/ButtonCancel'
  import {api} from '../../../api/ParkingService'
  import {errorHandler} from '../../../../utils/errorHandler'
  import {nError, nSuccess} from '../../../../utils/notice'
  import {pattern} from '../../../../utils/regular'

  export default {
    components: {
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'free-code-author-add',
    data () {
      return {
        breadcrumb: [{
          value: '智慧停车',
          name: 'parking-device-management'
        }, {
          value: '其他配置'
        }],
        mainTitle: '添加授权人',
        subheading: '',

        responsiblePersonList: [],
        formData: {
          code: '',
          name: '',
          phone: '',
          enterpriseName: '',
          codeInResourcePerson: '',
          memo: '',
        }
      }
    },
    created () {
      this.remoteMethod()
    },
    methods: {
      remoteMethod (query) {
        this.getResponsiblePerson(query)
      },
      // 查询授权对象
      getResponsiblePerson (searchKey) {
        this.$axios.post(api.getResponsiblePersonList, {
          searchKey: searchKey || ''
        })
          .then(res => {
            let list = res.data.data
            list.forEach(it => {
              it._value = it.code
              it._label = `${it.name} / ${it.phone} / ${it.enterpriseName}`
            })
            this.responsiblePersonList = list
          })
          .catch(errorHandler('查询失败'))
      },
      toMangePage () {
        this.$router.push({
          name: 'free-code-author'
        })
      },

      // 确认添加
      confirm () {
        if (!this.formData.codeInResourcePerson) {
          nError('请选择授权人')
          return false
        }
        this.responsiblePersonList.map(v => {
          if (v.code === this.formData.codeInResourcePerson) {
            this.formData.name = v.name
            this.formData.phone = v.phone
            this.formData.enterpriseName = v.enterpriseName
          }
        })
        this.$axios.post(api.addOtherConfigAuthorizer, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('添加成功')
              this.toMangePage()
            }
          })
          .catch(errorHandler('添加失败'))
      },
      cancel () {
        this.toMangePage()
      }
    },
    watch: {}
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-line {
    margin: 20px 0;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 120px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/ParkingOtherConfig/FreeCodeAuthor/FreeCodeAuthorAdd.vue